<template>
    <div>
        {{ animatedNumber }}
    </div>
</template>

<script>
export default {
    name: 'counter',
    props: {
        number: {
            type: Number,
            default: 0
        },
        duration: {
            type: Number,
            default: 1000
        },
        easing: {
            type: String,
            default: 'easeOutSine'
        },
        round: {
            type: Number,
            default: 1
        },
        delay: {
            type: Number,
            default: 0
        },
        useDecimalSeperator: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            animatedNumber: 0
        };
    },
    mounted() {
        this.$anime({
            targets: this.$data,
            animatedNumber: this.number,
            ...this.$props,
            update: anim => {
                if (!this.useDecimalSeperator) return anim;
                if (anim.animations[0].animatable.target.animatedNumber) {
                    if (
                        anim.animations[0].animatable.target.animatedNumber >=
                        1000
                    ) {
                        anim.animations[0].animatable.target.animatedNumber = anim.animations[0].animatable.target.animatedNumber
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
                    }
                }
                if (anim.animations[0].animatable.target.animatedNumber < 100) {
                    return (anim.animations[0].animatable.target.animatedNumber = anim.animations[0].animatable.target.animatedNumber
                        .toString()
                        .replace('.', ','));
                }
                return anim;
            }
        });
    }
};
</script>

<style lang="scss" scoped>
</style>
